import bg1 from '../assets/images/background/bg1.jpg'
import bg2 from '../assets/images/background/bg2.jpg'
import bg3 from '../assets/images/background/bg3.jpg'
import bg4 from '../assets/images/background/bg4.jpg'
import bg5 from '../assets/images/background/bg5.jpg'
import bg6 from '../assets/images/background/bg6.jpg'
import bg7 from '../assets/images/background/bg7.jpg'

export const BACKGROUNDS = {
    bg1: {
        id: 'bg1',
        label: 'Blackboard',
        type: 'image',
        image: bg1,
    },
    bg2: {
        id: 'bg2',
        label: 'Thanks Giving',
        type: 'image',
        image: bg2,
    },
    bg3: {
        id: 'bg3',
        label: 'Christmas',
        type: 'image',
        image: bg3,
    },
    bg4: {
        id: 'bg4',
        label: 'New Year',
        type: 'image',
        image: bg4,
    },
    bg5: {
        id: 'bg5',
        label: 'Halloween',
        type: 'image',
        image: bg5,
    },
    bg6: {
        id: 'bg6',
        label: 'Pine Cones',
        type: 'image',
        image: bg6,
    },
    bg7: {
        id: 'bg7',
        label: 'Light Trails',
        type: 'image',
        image: bg7,
    },
    color1: {
        id: 'color1',
        label: 'Black',
        type: 'color',
        color: '#0c0f1a',
    },
    gradient1: {
        id: 'gradient1',
        label: 'Ocean',
        type: 'gradient',
        gradient: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
    },
    gradient2: {
        id: 'gradient2',
        label: 'Midnight',
        type: 'gradient',
        gradient: 'linear-gradient(135deg, #000000 0%, #434343 100%)',
    },
    gradient3: {
        id: 'gradient3',
        label: 'Dark Knight',
        type: 'gradient',
        gradient: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
    },
    gradient4: {
        id: 'gradient4',
        label: 'Purple Haze',
        type: 'gradient',
        gradient: 'linear-gradient(135deg, #360033 0%, #0b8793 100%)',
    },
};